import { useIntl } from 'react-intl';
import type { messages as enMessages } from '../i18n/translations/en';
import { useLanguage } from '../i18n/LanguageContext';

type NestedKeys<T> = T extends object
  ? { [K in keyof T]: `${K & string}${T[K] extends object ? `.${NestedKeys<T[K]>}` : ''}` }[keyof T]
  : never;

type FlattenedKeys = NestedKeys<typeof enMessages>;

export const useTranslation = () => {
  const intl = useIntl();
  const { language, setLanguage, getLocalizedPath, getUnlocalizedPath } = useLanguage();

  const t = (key: FlattenedKeys, values?: Record<string, string | number>) => {
    return intl.formatMessage({ id: key }, values);
  };

  return {
    t,
    locale: language,
    setLocale: setLanguage,
    getLocalizedPath,
    getUnlocalizedPath
  };
}; 